import React from "react";

const PageHeader = ({ title }) => {
  return (
    <div style={styles.header}>
      <h1 style={styles.title}>{title}</h1>
    </div>
  );
};

const styles = {
  header: {
    padding: "10px 20px", // Subtle spacing around the title
    textAlign: "left",
  },
  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "bold",
    color: "#333", // Neutral, subtle color for branding
  },
};

export default PageHeader;
